import { VendorRanking } from 'src/app/classes/models/vendor-ranking';
import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';

export class CompanyServiceRanking extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static CompanyServiceRankingProperties: (
    | {
        property: keyof CompanyServiceRanking;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof CompanyServiceRanking;
        type: 'alias';
      }
    | {
        property: keyof CompanyServiceRanking;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'rank', type: 'column', dataType: 'string' },
    { property: 'priorityLevel', type: 'column', dataType: 'string' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },
    { property: 'allocationLimit', type: 'column', dataType: 'number' },
    {
      property: 'isTradeCategorySpecific',
      type: 'column',
      dataType: 'boolean'
    },
    { property: 'isTradeSpecific', type: 'column', dataType: 'boolean' },

    { property: 'VendorRankings', model: 'VendorRanking', type: 'association' }
  ];

  static {
    CompanyServiceRanking.CompanyServiceRankingProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          CompanyServiceRanking.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          CompanyServiceRanking.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          CompanyServiceRanking.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(CompanyServiceRankingObject: Partial<CompanyServiceRanking>) {
    super();

    CompanyServiceRanking.CompanyServiceRankingProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = CompanyServiceRankingObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  rank?: string;
  priorityLevel?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10';
  CompanyId?: number;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  allocationLimit?: number | null;
  isTradeCategorySpecific?: boolean;
  isTradeSpecific?: boolean;

  VendorRankings?: VendorRanking[];
}
